// src/App.js

import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import Layout from './components/Layout';
import PostsPending from './components/PostsPending';
import Login from './components/Login';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import ContactUs from './components/ContactUs';
import DeleteRequestList from './components/DeleteRequestList';
import Settings from './components/Settings';

const App = () => {
  const isLoggedIn = localStorage.getItem('loggedIn');
  return (
    <div className="App">
      <Layout isLoggedIn={isLoggedIn}>
        <Routes>
          {isLoggedIn && <Route path="/home" element={<Home />} />} {/* Show Home page if logged in */}
          {isLoggedIn && <Route path="/posts/pending" element={<PostsPending />} />}

          {isLoggedIn && <Route path="/posts/deleterequestlist" element={<DeleteRequestList />} />}
          {isLoggedIn && <Route path="/settings" element={<Settings />} />}
        </Routes>
      </Layout>
      <Routes>
        {!isLoggedIn && <Route path="/" element={<Login />} />}
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/termsandconditions" element={<TermsAndConditions />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/contactus" element={<ContactUs />} />

      </Routes>
    </div>
  );
}

export default App;
